export default {
  fields: {
    code: 'Koodi',
    tag: 'Tunniste',
    type: 'Tyyppi',
    discount_type: 'Alennustyyppi',
    discount: 'Alennus',
    usage_threshold: 'Käyttöraja',
    quantity: 'Määrä',
    expires_at: 'Vanhenee',
    customers: 'Asiakkaat',
    purchases: 'Tilaukset',
    sales: 'Myynti',
    level: 'Taso',
    max_discount: 'Enimmäisalennus',
  },
  tags: {
    master: 'Pääkoodi',
    campaign: 'Kampanja',
    one_time: 'Kertaluonteinen',
  },
  types: {
    single_use: 'Kertakäyttöinen',
    multi_use: 'Monikäyttöinen',
    unknown: 'Tuntematon',
  },
  discount_types: {
    fixed_amount: 'Kiinteä summa',
    percentage: 'Prosenttiosuus',
    unknown: 'Tuntematon',
  },
  labels: {
    discount: 'Alennus',
    usage_threshold: 'Käyttöraja',
    company: 'Yritys',
  },
  collecting_emails: {
    description:
      'Tässä voit määrittää kertaluonteisen alennuskoodin, joka luodaan uusille käyttäjille, kun he rekisteröityvät verkkosivustolla.',
  },
  buttons: {
    edit: 'Muokkaa',
  },
  toasts: {
    successfully_deleted: 'Alennuskoodiasetukset poistettiin onnistuneesti',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
